"use client";
import { useEffect, useState } from "react";

// The app is light-only and nothing reads the theme (no useTheme consumers),
// so next-themes is not used here: its provider injects an inline <script>
// that React 19 warns about when rendered on the client
// ("Encountered a script tag while rendering React component").
// The mounted gate is kept to preserve the previous client-only render.
const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return <>{children}</>;
};

export default ThemeProvider;
